import { combineReducers } from 'redux';
import user from './user';
import language from './language';
import message from './message';

export default combineReducers({
  user,
  message,
  language
});
